import { Component, OnInit, Output, OnDestroy } from '@angular/core';
import { EventEmitter } from 'events';
import { MessageService } from '../../services/message-service'
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'toggle-to-switch',
  templateUrl: './toggle-to-switch.component.html',
  styleUrls: ['./toggle-to-switch.component.scss'],
})
export class ToggleToSwitchComponent implements OnInit, OnDestroy {
  selectedToggle = 'Warehouse';
  private unsubscribe: Subject<void> = new Subject();
  constructor(private message: MessageService) { }

  switchComponent(selectedValue) {
    this.selectedToggle = selectedValue
    this.message.sendMessage({ selectedValue });
  }

  ngOnInit() {
    this.message.getMessage().pipe(takeUntil(this.unsubscribe)).subscribe(value => {
      if(value.selectedValue){
        this.selectedToggle = value.selectedValue
      }
    })
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
